import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route } from "react-router";

import { appLaunched, appOpened } from "../store/modules/amplitude/actions";
import { audioSetVoice, changeRate, requestOfflineVoices } from "../store/modules/audio/actions";
import { hasSelectedVoice, getVoices } from "../store/modules/audio/selectors";
import {
  requestLibrary,
  subscribeToFolder,
  subscribeToRecord,
} from "../store/modules/library/actions";

import { Home } from "./components/Home";
import { SettingsPage } from "./pages/Settings";

import { useShortcuts } from "./hooks/useShortcuts";

const actions = [
  appLaunched,
  changeRate,
  subscribeToFolder,
  subscribeToRecord,
  requestLibrary,
  requestOfflineVoices,
  changeRate,
];

export const App: React.FC = () => {
  const dispatch = useDispatch();
  const { length: voicesLength } = useSelector(getVoices);
  const selectedVoice = useSelector(hasSelectedVoice);

  useEffect(() => {
    actions.forEach((action) => {
      dispatch(action());
    });
  }, [dispatch]);

  useEffect(() => {
    if (voicesLength && !selectedVoice) {
      dispatch(audioSetVoice());
    }
  }, [voicesLength, selectedVoice, dispatch]);

  useEffect(() => {
    const handleOnVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        dispatch(appOpened());
      }
    };

    document.addEventListener("visibilitychange", handleOnVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleOnVisibilityChange);
    };
  }, [dispatch]);

  useShortcuts();

  return (
    <>
      <Route path="/settings" component={SettingsPage} />

      <Home />
    </>
  );
};
